import * as React from 'react';
import Alert from 'react-bootstrap/Alert';

import { useAlertService } from '../services/alert.service';
import { useForceUpdate } from '../shared/hooks';

export function AlertComponent() {
  const alertService = useAlertService();
  const forceUpdate = useForceUpdate();

  React.useEffect(() => {
    alertService.alertsListSubject.subscribe(forceUpdate);
  }, [alertService.alertsListSubject, forceUpdate]);

  return (
    <div className="alert-container">
      {alertService.alertsList.map((alert, i) => (
        <Alert
          key={`${i}-${alert.message}`}
          dismissible={alert.dismissible}
          onClose={() => alertService.removeAlertFromList(i)}
          variant={alert.level}
        >
          {alert.message}
        </Alert>
      ))}
    </div>
  );
}
